import { render, staticRenderFns } from "./SPChannels.vue?vue&type=template&id=79e66a1d&"
import script from "./SPChannels.vue?vue&type=script&lang=ts&"
export * from "./SPChannels.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports